
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12px","height":"12px","viewBox":"0 0 12 12","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('Shape')]),_c('g',{attrs:{"id":"4.-Annotate","stroke":"none","stroke-width":"1","fill":"currentColor","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"2","transform":"translate(-631.000000, -454.000000)","fill":"currentColor"}},[_c('g',{attrs:{"id":"Group-21","transform":"translate(353.000000, 435.000000)"}},[_c('path',{attrs:{"d":"M289.775,19.225 C289.475,18.925 289.025,18.925 288.725,19.225 L284,23.95 L279.275,19.225 C278.975,18.925 278.525,18.925 278.225,19.225 C277.925,19.525 277.925,19.975 278.225,20.275 L282.95,25 L278.225,29.725 C277.925,30.025 277.925,30.475 278.225,30.775 C278.375,30.925 278.525,31 278.75,31 C278.975,31 279.125,30.925 279.275,30.775 L284,26.05 L288.725,30.775 C288.875,30.925 289.1,31 289.25,31 C289.4,31 289.625,30.925 289.775,30.775 C290.075,30.475 290.075,30.025 289.775,29.725 L285.05,25 L289.775,20.275 C290.075,19.975 290.075,19.525 289.775,19.225 Z","id":"Shape"}})])])])])
          )
        }
      }
    